import React, { useState, useEffect, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import PatientCrmPersonal from "./PatientCrmPersonal";
import PatientContact from "./PatientContact";
import Order from "./Order";
import ReferenceAndContact from "./ReferenceAndContact";
import StepsWizard from "../../../components/templates/StepsWizard";
import { getChangedItems } from "../../../components/util/helpers";
import {
  createRecord,
  loadGlobalPatient,
  commitChanges,
  reset,
  setChangedFormItems,
  loadRecord,
} from "../../patientDetails/patientDetailsSlice";
import { updatePatient, createPatientReference } from "../../../api/server";
import { createRecord as createOrder } from "../../orderDetails/OrderDetailsSlice";
import { createReference } from "../../patientReferences/patientReferencesSlice";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { isAllowedFeature } from "../../organization/organizationSlice";
import { useLoadScript } from "@react-google-maps/api";
import {
  usePatient_opportunity_statuses,
  useRevahaAuthorities,
} from "../../../hooks";

import moment from "moment";
var flatten = require("flat");
var unflatten = require("flat").unflatten;
const libraries = ["places"];

const NewCrmPatientWizard = (props) => {
  const { hideWizard, onShowPatientCardClicked, type, record, fromCrm } = props;
  const [referrerType, setReferrerType] = useState(null);
  const patient_opportunity_statuses = usePatient_opportunity_statuses();
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDs2QkqANgCTQIcThQFCiNkxcKGPVkS_lM",
    libraries: libraries,
    language: "he",
  });
  const dispatch = useDispatch();
  let location = useLocation();
  let { branchId } = useParams();
  let history = useHistory();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [values, setValues] = useState({});
  const [addContact, setAddContact] = useState(false);
  const [addReference, setAddReference] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isSupportingCommunity, setIsSupportingCommunity] = useState(true);
  const [isDayCenter, setIsDayCenter] = useState(false);
  const [clientCategories, setClientCategories] = useState([]);
  const [selectedClientTariffSymbol, setSelectedClientTariffSymbol] =
    useState(null);
  const [selectedRevahaAuthority, setSelectedRevahaAuthority] = useState(null);
  const revahaAuthorities = useRevahaAuthorities();
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const loadGlobalLoading = useSelector(
    (state) => state.pendingActions["patientDetails/loadGlobalPatient"]
  );
  const createLoading = useSelector(
    (state) => state.pendingActions["patientDetails/create"]
  );
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );

  const changedItems = useSelector(
    (state) => state.patientDetails.changedItems.changed
  );

  const isTrom =
    selectedClient &&
    selectedClient.category &&
    selectedClient.category.is_trom === true;

  let slide2Validation = ["first_name", "surename", "gender_id"];
  if (type !== "candidate") {
    slide2Validation.push("local_id_number");
  }
  if (!branchId) {
    slide2Validation.push("branch");
  }
  if (process.env.REACT_APP_CONFIG === "matav") {
    slide2Validation.push("referrer_id");
    if (referrerType === "employees") {
      slide2Validation = slide2Validation.filter(
        (item) => item !== "sub_referrer_id"
      );
      slide2Validation.push("employee_id");
    } else {
      slide2Validation = slide2Validation.filter(
        (item) => item !== "employee_id"
      );
      slide2Validation.push("sub_referrer_id");
    }
  }
  if (isAllowedFeature("accounting_tag")) {
    slide2Validation.push("branch_extension_id");
    slide2Validation.push("subproject_id");
  }
  let slide3Validation = isSupportingCommunity
    ? [
        "client.category_id",
        "client_id",
        "effective_from",
        "order_service_type_id",
      ]
    : isDayCenter
    ? [
        "client.category_id",
        "client_id",
        "effective_from",
        "order_service_type_id",
        "day_center_tariff_id",
      ]
    : [
        "client.category_id",
        "client_id",
        "service_type",
        "max_hours",
        "effective_from",
        "order_service_type_id",
      ];

  let candidateSlide3Validation =
    addContact && addReference
      ? [
          "relatives.first_name",
          "relatives.relative_type_id",
          "references.reference_time",
          "references.referrer_id",
          "references.sub_referrer_id",
          "references.employee_id",
        ]
      : addContact
      ? ["relatives.first_name", "relatives.relative_type_id"]
      : addReference
      ? [
          "references.reference_time",
          "references.referrer_id",
          "references.sub_referrer_id",
          "references.employee_id",
        ]
      : [];

  if (referrerType === "employees" && addReference) {
    candidateSlide3Validation = candidateSlide3Validation.filter(
      (item) => item !== "references.sub_referrer_id"
    );
    candidateSlide3Validation.push("references.employee_id");
  } else if (referrerType === "sub_referrers" && addReference) {
    candidateSlide3Validation = candidateSlide3Validation.filter(
      (item) => item !== "references.employee_id"
    );
    candidateSlide3Validation.push("references.sub_referrer_id");
  }
  if (!values.no_end_date) {
    slide3Validation.push("effective_to");
  }
  if (isTrom) {
    slide3Validation.push("trom_target_client_id");
  }

  if (selectedClient?.category?.holocast_fund) {
    slide3Validation.push("commitment_number");
  }

  const changeSelectedClient = (val) => {
    setSelectedClient(val);
  };

  const changeValues = (val) => {
    setValues({ ...values, ...val });
  };

  const onAddContact = (val) => {
    setAddContact(val);
  };
  const onAddReference = (val) => {
    setAddReference(val);
  };

  const changeReferrerType = (val) => {
    setReferrerType(val);
  };

  useEffect(() => {
    if (type === "convert") {
      const isAdmin = location.pathname.includes("admin");
      const params = {
        id: record.id,
        branchId: branchId,
        admin: isAdmin,
      };
      dispatch(loadRecord(params));
    }
  }, [type]);

  const hide = () => {
    setNextDisabled(true);
    setValues({});
    hideWizard();
  };

  const setNext = (val) => {
    setNextDisabled(val);
  };

  const changeCurrentSlide = (val) => {
    setCurrentSlide(val);
  };

  const savePatientDetails = async () => {
    try {
      const deepValues = getDeepValues();
      const geo = deepValues.address
        ? await getGeolocation(deepValues.address)
        : {};
      const action = await handlePatientAction(deepValues, geo);
      if (action.error) {
        throw new Error("Error saving patient details");
      }
      const id = action.payload.data.id;
      if (addReference) {
        await handleCreatePatientReference(id, values.references);
      }
      return { id, action };
    } catch (error) {
      console.error(error);
      return { error };
    }
  };

  const getDeepValues = () => {
    const deepValues = unflatten(values, {
      safe: true,
    });
    if (values["birthday"]) {
      deepValues["birthday"] = values["birthday"];
    }
    if (addContact) {
      deepValues["relatives"] = [values["relatives"]];
    } else if (type === "candidate") {
      deepValues["relatives"] = [];
    }
    return deepValues;
  };

  const getGeolocation = async (addressDetails) => {
    const address = `${addressDetails.city}, ${addressDetails.street} ${addressDetails.house_number}`;
    const predictions = await getNewAddress(address);
    return getGeo(predictions["predictions"]);
  };

  const handlePatientAction = async (deepValues, geo) => {
    const isAdmin = location.pathname.includes("admin");
    const branchIdValue = isAdmin ? values.branch : branchId;
    const newId = patient_opportunity_statuses.find(
      (i) => i.name === "new"
    )?.id;
    const local_id_number =
      deepValues.local_id_number === ""
        ? null
        : deepValues.local_id_number?.padStart(9, "0");

    const patientParams = {
      patient: {
        ...deepValues,
        local_id_number,
        geo,
        status_id: 1,
        opportunity_status_id: newId,
      },
      branchId: branchIdValue,
      fromCrm: props?.fromCrm,
    };

    if (type === "convert") {
      return dispatch(commitChanges({ fromCrm }));
    } else {
      return dispatch(createRecord(patientParams));
    }
  };

  const handleCreatePatientReference = async (patientId, reference) => {
    const isAdmin = location.pathname.includes("admin");
    const branchIdValue = isAdmin ? values.branch : branchId;

    const referenceParams = {
      reference: reference,
      branchId: branchIdValue,
      patientId: patientId,
    };

    return createPatientReference(referenceParams);
  };

  const onFinish = async (formValues) => {
    try {
      const saveResult = await savePatientDetails();
      if (saveResult.error) {
        throw new Error("Error in saving patient details");
      }
      if (type === "candidate") {
        navigateToPatient(saveResult.id);
        return;
      }

      await handleOrderCreation(formValues, saveResult.id);
      await updatePatientStatus(
        saveResult.id,
        saveResult.action.payload.data.branch_id
      );

      if (process.env.REACT_APP_CONFIG === "matav") {
        await createMatavReference(
          formValues,
          saveResult.id,
          saveResult.action.payload.data.branch_id
        );
      } else {
        navigateToPatient(
          saveResult.id,
          saveResult.action.payload.data.branch_id
        );
      }
    } catch (error) {
      console.error(error);
      hide();
    }
  };

  const navigateToPatient = (patientId, branch_id = null) => {
    const isAdmin = location.pathname.includes("admin");
    const route =
      type === "candidate"
        ? `/crm_patients/${patientId}`
        : `/patients/${patientId}`;
    const url = isAdmin
      ? `/admin${route}`
      : `/branches/${branch_id || branchId}${route}`;
    history.push(url);
  };

  const handleOrderCreation = async (formValues, patientId) => {
    const deepValues = unflatten(formValues);
    deepValues.patient = patientId;
    deepValues.client = deepValues.client_id;
    deepValues.effective_to = formValues.no_end_date
      ? null
      : deepValues.effective_to;

    const isAdmin = location.pathname.includes("admin");
    const params = {
      order: deepValues,
      branchId: isAdmin ? values.branch : branchId,
      patientId: patientId,
    };

    await dispatch(createOrder(params));
  };
  const updatePatientStatus = async (patientId, branchId) => {
    const activePatientStatusId = patient_opportunity_statuses.find(
      (i) => i.name === "active_patient"
    )?.id;

    const updateParams = {
      patient: {
        id: patientId,
        opportunity_status_id: activePatientStatusId,
      },
      branchId: branchId,
      fromCrm: fromCrm,
    };

    const action = await updatePatient(updateParams);
    if (action.error) {
      throw new Error("Error updating patient status");
    }
  };
  const createMatavReference = async (formValues, patientId, branchId) => {
    const referenceParams = {
      reference: {
        reference_time: moment().format(),
        referrer_id: formValues.referrer_id,
        sub_referrer_id: formValues.sub_referrer_id,
        employee_id: formValues.employee_id,
      },
      branchId: branchId,
      patientId: patientId,
      referenceId: null,
    };

    const referenceAction = await dispatch(createReference(referenceParams));
    if (referenceAction.error) {
      throw new Error("Error creating Matav reference");
    } else {
      navigateToPatient(patientId, branchId);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getNewAddress = async (address) => {
    const places =
      isLoaded && new window.google.maps.places.AutocompleteService();
    const predictions = await places.getPlacePredictions({
      ...props.searchOptions,
      input: address,
    });
    return predictions;
  };

  const getGeo = async (predictions) => {
    if (predictions && predictions.length > 0) {
      const results = await geocodeByAddress(predictions[0].description);
      const latLng = await getLatLng(results[0]);
      const geo = {
        longtitude: latLng.lng,
        latitude: latLng.lat,
        address_line: predictions[0].description,
      };
      return geo;
    }
  };

  const onValuesChange = async (changedValues, allValues, form) => {
    const newValues = unflatten(allValues);
    setValues({ ...values, ...newValues });
    // Handle client category changes
    if (changedValues["client.category_id"]) {
      handleCategoryChange(changedValues["client.category_id"], form);
    }

    // Handle client tariff symbol changes
    handleClientTariffSymbolChange(changedValues);

    // Handle revaha authority changes
    handleRevahaAuthorityChange(changedValues);

    if (changedValues.local_id_number) {
      if (isId(changedValues.local_id_number)) {
        const filter = {
          local_id_number: changedValues.local_id_number?.padStart(9, "0"),
        };
        const params = {
          scopePrefix,
          filter: {
            ...filter,
          },
        };
        const action = await dispatch(loadGlobalPatient(params));
        if (action.payload && action.payload.id) {
          const flattenRecord = flatten(action.payload, { safe: true });
          onShowPatientCardClicked(flattenRecord, false);
          hideWizard();
          dispatch(reset());
        }
      }
    }
    if (currentSlide !== 2 || type === "candidate") {
      const arr = getChangedItems(
        changedValues,
        allValues,
        changedItems,
        activePatient
      );
      dispatch(setChangedFormItems({ changed: arr, values: allValues }));
    }
  };

  const isId = (value) => {
    let strId = String(value).trim();
    if (strId.length > 9 || strId.length < 8) {
      return false;
    }
    if (strId.length < 9) {
      while (strId.length < 9) strId = "0" + strId;
    }
    let counter = 0,
      rawVal,
      actualVal;
    for (let i = 0; i < strId.length; i++) {
      rawVal = Number(strId[i]) * ((i % 2) + 1);
      actualVal = rawVal > 9 ? rawVal - 9 : rawVal;
      counter += actualVal;
    }
    if (counter % 10 === 0) {
      return true;
    } else {
      return false;
    }
  };

  // handle changes in category
  const handleCategoryChange = (categoryId, form) => {
    const category = clientCategories.find((i) => i.id === categoryId);
    if (category) {
      form.setFieldsValue({
        order_service_type_id: category.default_service_type_id,
      });
    }
  };

  /**
   * Filters client frame symbols based on the selected client's frame symbols.
   *
   * @param {Array} items - The full list of client frame symbols to filter.
   * @returns {Array} A filtered list of client frame symbols that are associated with the selected client.
   */
  const filterClientFrameSymbols = (items) => {
    // Extract the IDs of the client frame symbols associated with the selected client
    const clientFrameSymbolsIds = selectedClient?.client_frame_symbols
      ? selectedClient.client_frame_symbols.map((item) => item.id)
      : [];

    // Filter the items, keeping only those whose IDs are in the clientFrameSymbolsIds array
    return items.filter((i) => clientFrameSymbolsIds.includes(i.id));
  };

  /**
   * Filters client tariff symbols based on the selected client's tariff symbols.
   *
   * @param {Array} items - The full list of client tariff symbols to filter.
   * @returns {Array} A filtered list of client tariff symbols that are associated with the selected client.
   */
  const filterClientTariffSymbols = (items) => {
    // Extract the IDs of the client tariff symbols associated with the selected client
    const clientTariffSymbolsIds = selectedClient?.client_tariff_symbols
      ? selectedClient.client_tariff_symbols.map((item) => item.id)
      : [];

    // Filter the items, keeping only those whose IDs are in the clientTariffSymbolsIds array
    return items.filter((i) => clientTariffSymbolsIds.includes(i.id));
  };

  const handleClientTariffSymbolChange = useCallback(
    (changedValues) => {
      if (
        changedValues &&
        typeof changedValues === "object" &&
        "client_tariff_symbol_id" in changedValues
      ) {
        const newTariffSymbolId = changedValues.client_tariff_symbol_id;
        if (newTariffSymbolId && selectedClient) {
          const newTariffSymbol = (
            selectedClient.client_tariff_symbols || []
          ).find((symbol) => symbol.id === newTariffSymbolId);
          setSelectedClientTariffSymbol(newTariffSymbol || null);
        } else {
          setSelectedClientTariffSymbol(null);
        }
      }
    },
    [selectedClient, setSelectedClientTariffSymbol]
  );

  const handleRevahaAuthorityChange = useCallback(
    (changedValues) => {
      if (
        changedValues &&
        typeof changedValues === "object" &&
        "revaha_authority_id" in changedValues
      ) {
        const newAuthorityId = changedValues.revaha_authority_id;
        if (newAuthorityId) {
          const newAuthority = revahaAuthorities.find(
            (auth) => auth.id === newAuthorityId
          );
          setSelectedRevahaAuthority(newAuthority || null);
        } else {
          setSelectedRevahaAuthority(null);
        }
      }
    },
    [revahaAuthorities, setSelectedRevahaAuthority]
  );

  const steps = [
    {
      title: null,
      description: null,
      headline: null,
      subtitle: <FormattedMessage id="app.patients.personalSubtitle" />,
      required: slide2Validation,
      validation: slide2Validation,
      comp: (
        <PatientCrmPersonal
          values={values}
          branchId={branchId}
          type={type}
          record={record}
          changeValues={changeValues}
          referrerType={referrerType}
          setReferrerType={setReferrerType}
        />
      ),
    },
    {
      title: null,
      description: null,
      subtitle: <FormattedMessage id="app.patients.addressSubtitle" />,
      required: [],
      validation: ["contact_info.phone_number", "contact_info.mobile_number"],
      comp: <PatientContact type={type} record={record} />,
    },
  ];

  if (type !== "candidate") {
    steps.push({
      title: null,
      description: null,
      headline: null,
      subtitle: <FormattedMessage id="app.patients.newPatientOrder" />,
      required: slide3Validation,
      validation: slide3Validation,
      comp: (
        <Order
          values={values}
          changeSelectedClient={changeSelectedClient}
          setIsSupportingCommunity={setIsSupportingCommunity}
          isSupportingCommunity={isSupportingCommunity}
          setIsDayCenter={setIsDayCenter}
          isDayCenter={isDayCenter}
          branchId={
            location.pathname.includes("admin") ? values.branch : branchId
          }
          setClientCategories={setClientCategories}
          clientCategories={clientCategories}
          filterClientFrameSymbols={filterClientFrameSymbols}
          filterClientTariffSymbols={filterClientTariffSymbols}
          selectedClientTariffSymbol={selectedClientTariffSymbol}
          selectedRevahaAuthority={selectedRevahaAuthority}
        />
      ),
    });
  } else {
    steps.push({
      title: null,
      description: null,
      headline: null,
      subtitle: <FormattedMessage id="app.patients.referenceAndContact" />,
      required: candidateSlide3Validation,
      validation: candidateSlide3Validation,
      comp: (
        <ReferenceAndContact
          onAddContact={onAddContact}
          addContact={addContact}
          onAddReference={onAddReference}
          addReference={addReference}
          values={values}
          branchId={
            location.pathname.includes("admin") ? values.branch : branchId
          }
          changeReferrerType={changeReferrerType}
        />
      ),
    });
  }

  return (
    <StepsWizard
      steps={steps}
      setNext={setNext}
      changeCurrentSlide={changeCurrentSlide}
      changeValues={changeValues}
      values={values}
      onCancel={hide}
      onValuesChange={onValuesChange}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={hide}
      saveLoading={createLoading}
      createText={<FormattedMessage id="app.patients.createNewPatient" />}
      nextDisabled={nextDisabled || loadGlobalLoading}
    />
  );
};

export default NewCrmPatientWizard;
